import axios from "axios";

export const PAYM8_RETRY_FAILURE_MESSAGE = "The order was created, but payment could not be started with PayM8.";
export const PAYM8_ALREADY_PAID_MESSAGE = "This order has already been paid.";

export function canRetryPaym8(paymentRetry) {
    return paymentRetry?.can_retry === true || paymentRetry?.can_retry === 1 || paymentRetry?.can_retry === "1";
}

export function getPaym8RetryEndpoint(paymentRetry, orderId) {
    return paymentRetry?.endpoint || `payments/order/${orderId}/retry-paym8`;
}

export function buildPaym8RetryUrl(endpoint) {
    const rawEndpoint = String(endpoint || "").trim();

    if (/^https?:\/\//i.test(rawEndpoint)) {
        return rawEndpoint;
    }

    const apiBase = process.env.REACT_APP_API_URL || "";
    const normalizedBase = apiBase.endsWith("/") ? apiBase : `${apiBase}/`;
    const normalizedEndpoint = rawEndpoint.replace(/^\/+/, "");

    if (normalizedEndpoint.startsWith("api/")) {
        return `${normalizedBase.replace(/api\/?$/, "")}${normalizedEndpoint}`;
    }

    return `${normalizedBase}${normalizedEndpoint}`;
}

export async function retryPaym8Order({ paymentRetry, orderId, token }) {
    return axios({
        method: "post",
        url: buildPaym8RetryUrl(getPaym8RetryEndpoint(paymentRetry, orderId)),
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getPaym8RetryErrorMessage(error) {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 409) {
        return PAYM8_ALREADY_PAID_MESSAGE;
    }

    if (status === 502) {
        return PAYM8_RETRY_FAILURE_MESSAGE;
    }

    return message || "Payment retry failed. Please try again.";
}

export function getPaym8RetryMessageType(error) {
    const status = error?.response?.status;

    if (status === 409) {
        return "success";
    }

    if (status === 502) {
        return "warning";
    }

    return "error";
}
